export default __webpack_public_path__ + "static/media/news.3a4dfb45.jpg";